module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "costMarginModal",
    staticClass: "ui modal",
    attrs: {
      "id": "productCostMarginModal"
    }
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.closeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Product Cost & Margin\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Configure costs to calculate accurate floor price")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading-container"
  }, [_c('div', {
    staticClass: "ui active centered inline loader"
  }), _vm._v(" "), _c('p', [_vm._v("Loading product data...")])]) : (_vm.error) ? _c('div', {
    staticClass: "error-container"
  }, [_c('i', {
    staticClass: "exclamation triangle icon"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": _vm.loadProductData
    }
  }, [_vm._v("Retry")])]) : (_vm.productData) ? _c('div', [_c('div', {
    staticClass: "product-info-section"
  }, [_c('div', {
    staticClass: "product-image"
  }, [(_vm.productData.product_info.image_url) ? _c('img', {
    attrs: {
      "src": _vm.productData.product_info.image_url,
      "alt": _vm.productData.product_info.name
    }
  }) : _c('div', {
    staticClass: "product-placeholder"
  }, [_c('i', {
    staticClass: "box icon"
  }), _vm._v(" "), _c('span', [_vm._v("Product")])])]), _vm._v(" "), _c('div', {
    staticClass: "product-details"
  }, [_c('h3', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.productData.product_info.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-meta"
  }, [_c('span', {
    staticClass: "asin"
  }, [_vm._v("ASIN: " + _vm._s(_vm.productData.product_info.asin))])]), _vm._v(" "), _c('div', {
    staticClass: "current-price"
  }, [_vm._v("\n            Current: " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.product_info.current_price)) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h4', {
    staticClass: "section-title"
  }, [_vm._v("YOUR COSTS")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Supplier Cost (COGS)")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "placeholder": "0.00"
    },
    domProps: {
      "value": _vm.formData.supplierCost
    },
    on: {
      "input": _vm.handleSupplierCostInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("What you paid your supplier")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Costs (per unit)")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "placeholder": "0.00"
    },
    domProps: {
      "value": _vm.formData.otherCosts
    },
    on: {
      "input": _vm.handleOtherCostsInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("Shipping, prep, labeling, customs — whatever applies to you")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group total-cost"
  }, [_c('label', [_vm._v("Total Landed Cost")]), _vm._v(" "), _c('div', {
    staticClass: "total-value"
  }, [_vm._v("\n            " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.calculatedData.totalLandedCost)) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h4', {
    staticClass: "section-title"
  }, [_vm._v("Amazon Fees (at " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.product_info.current_price)) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "fee-row"
  }, [_c('span', [_vm._v("\n            Referral Fee\n            "), (_vm.productData.amazon_fees.referral_fee_estimated) ? _c('span', {
    staticClass: "hint",
    attrs: {
      "title": "Amazon hasn't quoted this product's referral fee yet; using the most common rate (15%)."
    }
  }, [_vm._v("(estimated)")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "fee-value"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.amazon_fees.referral_fee)))])]), _vm._v(" "), (_vm.productData.amazon_fees.fba_fee_applies) ? _c('div', {
    staticClass: "fee-row"
  }, [_c('span', [_vm._v("FBA Fulfillment Fee")]), _vm._v(" "), _c('span', {
    staticClass: "fee-value"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.amazon_fees.fba_fulfillment_fee)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fee-row total-fee"
  }, [_c('span', [_vm._v("Total Amazon Fees")]), _vm._v(" "), _c('span', {
    staticClass: "fee-value"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.amazon_fees.total)))])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h4', {
    staticClass: "section-title"
  }, [_vm._v("TARGET MARGIN")]), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('div', {
    staticClass: "radio-option",
    class: {
      active: _vm.formData.useGlobalDefault
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marginMode),
      expression: "marginMode"
    }],
    attrs: {
      "type": "radio",
      "id": "useGlobalDefault",
      "value": "global"
    },
    domProps: {
      "checked": _vm._q(_vm.marginMode, "global")
    },
    on: {
      "change": [function($event) {
        _vm.marginMode = "global"
      }, _vm.onMarginModeChange]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "useGlobalDefault"
    }
  }, [_c('span', {
    staticClass: "radio-label"
  }, [_vm._v("Use Global Default")]), _vm._v(" "), _c('span', {
    staticClass: "radio-value"
  }, [_vm._v(_vm._s(_vm.productData.target_margin.global_default_percentage) + "%")]), _vm._v(" "), _c('span', {
    staticClass: "radio-hint"
  }, [_vm._v("Same as all products")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio-option",
    class: {
      active: !_vm.formData.useGlobalDefault
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marginMode),
      expression: "marginMode"
    }],
    attrs: {
      "type": "radio",
      "id": "customOverride",
      "value": "custom"
    },
    domProps: {
      "checked": _vm._q(_vm.marginMode, "custom")
    },
    on: {
      "change": [function($event) {
        _vm.marginMode = "custom"
      }, _vm.onMarginModeChange]
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (!_vm.formData.useGlobalDefault) ? _c('div', {
    staticClass: "form-group custom-margin"
  }, [_c('label', [_vm._v("Custom Margin Target")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    attrs: {
      "type": "number",
      "step": "0.1",
      "min": "0",
      "max": "100",
      "placeholder": "0"
    },
    domProps: {
      "value": _vm.formData.customMarginPercentage
    },
    on: {
      "input": _vm.handleCustomMarginInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "percent"
  }, [_vm._v("%")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "summary-section"
  }, [_c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Your Landed Cost")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.calculatedData.totalLandedCost)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Break-even Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.calculatedData.breakEvenPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Current Margin @ " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.product_info.current_price)))]), _vm._v(" "), _c('span', {
    class: _vm.getMarginClass(_vm.calculatedData.currentMargin)
  }, [_vm._v("\n            • " + _vm._s(_vm.formatPrice(_vm.calculatedData.currentMargin.percentage)) + "% (" + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.calculatedData.currentMargin.amount)) + ")\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row floor-price"
  }, [_c('span', [_vm._v("Your Floor Price (@ " + _vm._s(_vm.effectiveMarginPercentage) + "% margin)")]), _vm._v(" "), _c('span', {
    staticClass: "floor-price-value"
  }, [_vm._v("\n            " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.calculatedData.floorPrice)) + "\n            "), (!_vm.formData.useGlobalDefault) ? _c('span', {
    staticClass: "override-badge"
  }, [_vm._v("OVERRIDE")]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "footer-buttons"
  }, [_c('button', {
    staticClass: "ui cancel button",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button save-button",
    class: {
      loading: _vm.saving
    },
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v("\n        Save Settings\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "customOverride"
    }
  }, [_c('span', {
    staticClass: "radio-label"
  }, [_vm._v("Custom Override")]), _vm._v(" "), _c('span', {
    staticClass: "radio-hint"
  }, [_vm._v("Set unique target")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-info"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('span', [_vm._v("Fees auto-update when price changes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c494172!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductCostMarginModal.vue
// module id = 769
// module chunks = 2